// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GRID */
.history-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

/* CARD */
.history-card {
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
  transition: transform 0.2s ease;
}

.history-card:hover {
  transform: translateY(-4px);
}

/* CONTENT */
.history-date {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.history-hours {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}

.history-time {
  font-size: 14px;
  color: #555;
}

.history-status {
  font-weight: 600;
  margin-top: 6px;
}

.history-status.leave {
  color: #e53935;
}

.history-status.half {
  color: #f57c00;
}

.history-reason {
  font-size: 13px;
  color: #555;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/AttendanceHistory.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* GRID */\r\n.history-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n/* CARD */\r\n.history-card {\r\n  padding: 16px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 14px rgba(0,0,0,0.08);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.history-card:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n/* CONTENT */\r\n.history-date {\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n  color: #333;\r\n}\r\n\r\n.history-hours {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.history-time {\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n.history-status {\r\n  font-weight: 600;\r\n  margin-top: 6px;\r\n}\r\n\r\n.history-status.leave {\r\n  color: #e53935;\r\n}\r\n\r\n.history-status.half {\r\n  color: #f57c00;\r\n}\r\n\r\n.history-reason {\r\n  font-size: 13px;\r\n  color: #555;\r\n  margin-top: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
